import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { DxTabsComponent } from 'devextreme-angular';
import { ActivatedRoute } from '@angular/router';
import { map, shareReplay } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs';
import { AccessType, AuthService, PermissionType } from '@services';
import { AppointmentDetailsComponent } from './appointment-details/appointment-details.component';
import { AppointmentHistoryComponent } from './appointment-history/appointment-history.component';

type TabKey = 'details' | 'history';

@Component({
    selector: 'app-appointment',
    imports: [
        AsyncPipe,
        DxTabsComponent,
        AppointmentDetailsComponent,
        AppointmentHistoryComponent,
    ],
    templateUrl: './appointment.component.html',
})
export class AppointmentComponent {
    private route = inject(ActivatedRoute);
    private auth = inject(AuthService);

    get showDetails(): boolean {
        return this.auth.checkPermission(PermissionType.AppointmentDetails, AccessType.ViewOnly);
    }

    get showHistory(): boolean {
        return this.auth.checkPermission(PermissionType.AppointmentHistory, AccessType.ViewOnly);
    }

    selectedTab: TabKey = this.showDetails ? 'details' : 'history';

    readonly number$ = this.route.paramMap.pipe(
        map((params) => params.get('number')),
        distinctUntilChanged(),
        shareReplay(1),
    );

    allTabs = [
        { key: 'details', text: 'Details', icon: 'fas fa-info-circle', permission: PermissionType.AppointmentDetails },
        { key: 'history', text: 'History', icon: 'fas fa-history', permission: PermissionType.AppointmentHistory },
    ];

    tabs = this.allTabs.filter((t) => this.auth.checkPermission(t.permission, AccessType.ViewOnly));
}
